import { render, staticRenderFns } from "./SelectedPublication.vue?vue&type=template&id=591260da&scoped=true"
import script from "./SelectedPublication.vue?vue&type=script&lang=js"
export * from "./SelectedPublication.vue?vue&type=script&lang=js"
import style0 from "./SelectedPublication.vue?vue&type=style&index=0&id=591260da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591260da",
  null
  
)

export default component.exports